import { ICarbonOffsetImpact } from "src/@types/impact";
import { formatNumber } from "./numberFormatter";
import { ProgrammeType } from "src/@types/programme";

const stringCapitalize = (str: string): string => {
  return str.trim().replace(/ /g, '_').toLocaleUpperCase();
}

const firstLetterUpperCase = (str?: string) => {
  if (!str) {
    return '';
  }

  return str.charAt(0).toUpperCase() + str.slice(1).toLocaleLowerCase();
}

const displayCo2Amount = (co2Offset: ICarbonOffsetImpact) => {
  if (!co2Offset?.value || !co2Offset?.unit) {
    return '';
  }

  return `${formatNumber(co2Offset.value)} ${co2Offset.unit.toLocaleLowerCase()}`
}

export const lowerCase = (str: string) => {
  return str.toLowerCase();
}

const readableStringFormatter = (str?: string) => {
  if (!str) return '';

  if (str.toLowerCase() === ProgrammeType.MYCARBONCLICK.toLowerCase()) return 'MyCarbonClick';

  return str?.charAt(0).toUpperCase() + str?.slice(1)?.toLowerCase().replaceAll('_', ' ');
};

const convertToConstantCase = (str: string) => {
  if (!str) {
    return '';
  }

  return str.toUpperCase().replace(/[\s-]+/g, '_');
}

const capitalizeFirstLetters = (str?: string) => {
  if (!str) return '';

  const words = str.split(/(\s+|-|\/)/);

  const capitalizedText = words
    .map((word) => {
      if (word.trim() === '') return word;
      else return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join('');

  return capitalizedText;
}

export {
  stringCapitalize,
  firstLetterUpperCase,
  displayCo2Amount,
  readableStringFormatter,
  convertToConstantCase,
  capitalizeFirstLetters,
};